<template>
  <footer class="footer">
    <b-container>
      <b-row>
        <b-col md="4" sm="6" class="mb-3">
          <h6 class="titles">
            {{ $t("links") }}
          </h6>
          <ul class="link_lists list-unstyled">
            <li class="items_here">
              <router-link class="every_link text-capitalize" to="/">{{
                $t("navbar.Home")
              }}</router-link>
            </li>
            <li class="items_here">
              <router-link class="every_link text-capitalize" to="/about">
                {{ $t("navbar.About") }}
              </router-link>
            </li>
            <li class="items_here">
              <router-link
                class="every_link text-capitalize"
                to="/contact-us"
                >{{ $t("navbar.contact us") }}</router-link
              >
            </li>
            <li class="items_here">
              <router-link
                class="every_link text-capitalize"
                to="/categories"
                >{{ $t("navbar.categories") }}</router-link
              >
            </li>
            <li class="items_here">
              <router-link class="every_link text-capitalize" to="/favorites">{{
                $t("navbar.Favorites")
              }}</router-link>
            </li>
            <li class="items_here">
              <router-link class="every_link text-capitalize" to="/requests">{{
                $t("navbar.Requests")
              }}</router-link>
            </li>
          </ul>
        </b-col>
        <b-col md="4" sm="6" class="mb-3">
          <h6 class="titles">{{ $t("Policy") }}</h6>
          <ul class="link_lists list-unstyled">
            <li class="items_here">
              <router-link class="every_link text-capitalize" to="/privacy">{{
                $t("Privacy Policy")
              }}</router-link>
            </li>
            <li class="items_here">
              <router-link class="every_link text-capitalize" to="/terms">{{
                $t("terms conditions")
              }}</router-link>
            </li>
          </ul>
          <div class="downloads_from_store">
            <a
              href="https://play.google.com/store/apps/details?id=com.smart.aldon"
              class="d-block"
            >
              <img class="img" src="@/assets/images/google.png" alt="google" />
            </a>
            <a
              href="https://apps.apple.com/gb/app/aldon/id6451424843"
              class="d-block mt-3"
            >
              <img class="img" src="@/assets/images/apple.png" alt="apple" />
            </a>
          </div>
        </b-col>
        <b-col md="4" sm="12" class="mb-3">
          <h6 class="titles">{{ $t("navbar.contact us") }}</h6>
          <ul class="website_info list-unstyled">
            <li class="info">
              <a class="info_link" :href="`mailto:${contacts.email}`">
                <font-awesome-icon
                  class="info_icon"
                  icon="fa-solid fa-envelope"
                />
                <span class="info_text">{{ contacts.email }}</span>
              </a>
            </li>
            <li class="info">
              <a class="info_link" :href="`tel:${contacts.phone}`">
                <font-awesome-icon class="info_icon" icon="fa-solid fa-phone" />
                <span class="info_text">{{ contacts.phone }}</span>
              </a>
            </li>
            <li class="info">
              <a
                class="info_link"
                target="_blank"
                :href="`https://wa.me/${contacts.phone}`"
              >
                <font-awesome-icon
                  class="info_icon"
                  icon="fa-brands fa-whatsapp"
                />
                <span class="info_text">{{ contacts.phone }}</span>
              </a>
            </li>
            <li class="info">
              <font-awesome-icon
                class="info_icon"
                icon="fa-solid fa-location"
              />
              <span class="info_text">{{ contacts.address }}</span>
            </li>
          </ul>
        </b-col>
      </b-row>
      <div class="rights">
        <span class="right_text">
          {{ $t("All Rights Reserved") }}
          &copy; 2023</span
        >
      </div>
    </b-container>
  </footer>
</template>

<script>
export default {
  name: "AppFooter",

  mounted() {
    // if (this.auth().token != null) {
    this.$store.dispatch("globalData/handlerContactData");
    // }
  },
  computed: {
    contacts() {
      return this.$store.getters["globalData/getContacts"];
    },
  },
};
</script>

<style lang="scss" scoped>
.footer {
  background-color: $bg_dark;
  color: $white_color;
  padding: 2.5rem 0 1rem 0;
  .downloads_from_store {
    .img {
      display: block;
      width: 180px;
      height: 50px;
      border: 1px solid #7a7a7a;
      border-radius: 10px;
    }
  }

  .link_lists {
    padding: 0;
    .items_here {
      margin-bottom: 15px;
      .every_link {
        color: $white_color;
        text-decoration: none;
        transition: $transition;
        display: block;
        width: fit-content;
        font-size: 14px;
        &:hover {
          color: $main_color;
          transform: translateX(8px);
        }
      }
    }
  }
  .website_info {
    padding: 0;
    .info {
      display: flex;
      gap: 5px;
      align-items: center;
      margin-bottom: 15px;
      .info_link {
        color: $white_color;
        text-decoration: none;
        transition: $transition;
        display: flex;
        gap: 5px;
        align-items: center;
      }
      .info_text {
        color: $white_color;
      }
      .info_icon {
        color: $main_color;
      }
    }
  }
  .titles {
    position: relative;
    letter-spacing: 1px;
    text-transform: uppercase;
    margin-bottom: 17px;
    font-weight: bold;
    &::first-letter {
      color: $main_color;
      font-size: 22px;
    }
  }
  .rights {
    position: relative;
    text-align: center;
    padding-top: 0.7rem;

    &::before {
      position: absolute;
      content: "";
      background: rgba($white_color, 0.5);
      height: 1px;
      width: 80%;
      top: 0;
      left: 10%;
    }
    .right_text {
      color: $white_color;
    }
  }
}
</style>
